import { useSuspenseQuery } from '@tanstack/react-query';

import { getPatentValidationHistoryOptions } from '@/module/Author/Patent/Validation/model/PatentValidationModel';

import { Id } from '@feature/utils';
import { ValidationHistoryContent } from '@feature/validation/ValidationHistoryContent';

interface PatentValidationHistoryProps {
  patentId: Id;
}

export function PatentValidationHistory({ patentId }: PatentValidationHistoryProps) {
  const { data: history } = useSuspenseQuery(getPatentValidationHistoryOptions(patentId));

  return <ValidationHistoryContent history={history} />;
}
